import React, { useEffect, useState, useContext } from "react";
import styles from "./Chat.module.sass";
import Box from "@mui/material/Box";
import cn from 'classnames';
import Friends from "../Friends";
import ChatContent from "./ChatContent";
import { UserContext } from "../../contexts/UserContext";
import WelcomeMessage from "./WelcomeMessage";
import Loader from "../../components/LoaderCircle";
import { ACTIONS } from "../../../Models/ENUM";
import ChatContextProvider from "../../contexts/ChatContext";
import { useParams, withRouter } from 'react-router-dom';

const Chat = ({simple, history}) => {

    const userContext = useContext( UserContext );
    const { friendID } = useParams();

    const [ roomKey, setRoomKey ] = useState( false );
    const [ isLoading, setIsLoading ] = useState( false );

    async function onFriendSelected( friendData ){

        if( !friendData ){
            history.push('/chat')
            return false;
        }

        if( friendData.status != 'active' ){
            setRoomKey( false );
            return false;
        }

        // if (!userContext.userData.isLogged) return false;

        if( simple ) history.push('/chat/' + friendData.avatarID)
        setRoomKey( [ friendData.avatarID ] );
        return true;

    }

    function onLoadingStateChange( newIsLoading ){
        setIsLoading( newIsLoading );
    }

    function onBackCallback(){
        setRoomKey( false );
    }

    return (
        <div className={cn(styles.container, simple && styles.simple)}>
            <Box
                className={styles.column_messages}>
                <Friends onSelected={onFriendSelected} initialSelectedFriend={friendID} simple={simple}/>
            </Box>
            <Box className={cn(styles.column_chat, roomKey && styles.active)}>
                {/* { (!roomKey || isLoading) && <WelcomeMessage isLoading={isLoading}/> } */}
                <ChatContextProvider isLoadingCallback={onLoadingStateChange} roomKeys={roomKey} isPersistent={true}>
                    {!isLoading && <ChatContent onBackCallback={onBackCallback}/>}
                </ChatContextProvider>
            </Box>
            
        </div>
    );
};

export default withRouter(Chat);
